import * as React from 'react';
import { SVGProps } from 'react';

const SvgFileIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={38} height={42} viewBox="0 0 38 42" fill="none" role="img" {...props}>
    <path d="m38 9.1-9-9v9h9Z" fill="#8E93AF" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29 0H10a4 4 0 0 0-4 4v34a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V9.1h-9V0Z"
      fill="currentColor"
      fillOpacity={0.1}
    />
    <rect y={21} width={32} height={12} rx={6} fill="currentColor" />
  </svg>
);

export default SvgFileIcon;
